/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



(function () {

    function fixLookifyBadges() {

        document.querySelectorAll(".hdt-card-product").forEach(function (card) {

            // Actual image wrapper
            const imageWrapper = card.querySelector(".hdt-card-product__media-wrapp");

            if (!imageWrapper) return;

            imageWrapper.style.position = "relative";
            imageWrapper.style.overflow = "hidden";

            // Find all badges
            const badges = card.querySelectorAll(".vton-badge-wrapper");

            if (!badges.length) return;

            // Keep only first badge
            const badge = badges[0];

            // Remove duplicates
            badges.forEach(function (b, i) {
                if (i > 0) b.remove();
            });

            // Move badge inside actual image wrapper
            if (badge.parentNode !== imageWrapper) {
                imageWrapper.appendChild(badge);
            }

            badge.style.cssText = `
                position:absolute !important;
                left:10px !important;
                bottom:10px !important;
                top:auto !important;
                right:auto !important;
                inset:auto auto 10px 10px !important;
                margin:0 !important;
                transform:none !important;
                z-index:99999 !important;
                pointer-events:auto !important;
            `;

        });

    }

    function init() {
        fixLookifyBadges();

        setTimeout(fixLookifyBadges, 200);
        setTimeout(fixLookifyBadges, 500);
        setTimeout(fixLookifyBadges, 1000);
    }

    window.addEventListener("load", init);
    window.addEventListener("resize", fixLookifyBadges);

    new MutationObserver(function () {
        requestAnimationFrame(fixLookifyBadges);
    }).observe(document.body, {
        childList: true,
        subtree: true
    });

})();